import React from 'react';
import { useNavigate } from 'react-router-dom';

const  JourneyCTA = ({ data }) => {
  console.log(data, "this is the data in ctaSection");
  const navigate = useNavigate();

  return (
    <section className="w-full  px-4 sm:px-6 max-w-5xl mx-auto ava-section-gap">
      {/* px-4 sm:px-6 */}
      <div
        className="relative flex flex-col sm:flex-row items-center justify-between gap-5 ava-radius-md overflow-hidden px-6 sm:px-8 py-7 sm:py-8 ava-card-bg ava-card-mukta"
      >
        {/* Text */}
        <div className="flex flex-col gap-1 flex-1 text-center sm:text-left ">
          <h3
            className="ava-heading-md "
          >
            {/* Not sure which program is right for you? */}
            {data?.heading}
          </h3>
          <p
            className="ava-text-body"
            style={{
              // maxWidth: '360px' 
            }}
          >
            {data?.description}
          </p>
        </div>

        {/* Button */}
        <div className="flex flex-col items-center gap-2 sm:items-end shrink-0">
          {data?.cta?.primary && (
            <button
              onClick={() => navigate(data?.cta?.primary?.href)}
              className="flex items-center gap-2 flex-shrink-0 btn-primary"
            >
              {/* Start Your Journey */}
              {data?.cta?.primary?.label}
              <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                <path d="M5 12h14M12 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
          )}
          {/* {data?.cta?.helperText && (
            <span className="flex items-center gap-1 ava-text-xs">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
              </svg>
             
              {data?.cta?.helperText}
            </span>)} */}
        </div>
      </div>
    </section>
  );
};

export default JourneyCTA;